function getCreditCardNetwork(cardNetwork?: string | null): "visa" | "mastercard" {
  return cardNetwork === "mastercard" ? "mastercard" : "visa";
}

export { getCreditCardNetwork };
